<template>
  <div>
    <top-nav></top-nav>
    <section class="clearfix">
      <el-breadcrumb separator-class="el-icon-arrow-right" class="mb20">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item v-for="(item, index) in routes"
                            :key="index">{{ item }}</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="clearfix">
        <el-col :span="6" class="full-line mr50">
          <el-col :span="12" class="href-line"></el-col>
          <p class="font24">报告类型</p>
        </el-col>
        <el-col :span="1"></el-col>
        <el-col :span="17" class="mt5">
          年份：
          <el-select v-model="year" placeholder="选择年份" class="mr10">
            <el-option v-for="item in years"
                       :key="item" :label="`${item}年`" :value="`${item}`"></el-option>
          </el-select>
          月份：
          <el-select v-model="month" placeholder="选择月份" class="mr10">
            <el-option v-for="item in months"
                       :key="item" :label="`${item}月`" :value="`${item}`"></el-option>
          </el-select>
          期数：
          <el-select v-model="week" placeholder="选择期数" @change="verifyRoot">
            <el-option v-for="item in weeks"
                       :key="item" :label="`${item}期`" :value="item"></el-option>
          </el-select>
        </el-col>
      </div>
      <left-nav class="left"></left-nav>
      <div class="left ml50">
        <pdf-preview v-if="showPdf"
                     class="pdf-box"
                     :code="code"
                     :file-id="fileId"
                     :file-name="fileName"></pdf-preview>
        <div class="report-list">
          <!--<p class="center title"><span>更多报告</span></p>-->
          <img src="../../assets/img/more_report.png" alt="report" class="img-title">
          <ul class="clearfix" v-if="lastDocs.length">
            <li class="left pointer"
                @click="changePdfView(last)"
                :class="nearIdx<lastDocs.length - 1?'mr5':''"
                v-for="(last,nearIdx) in lastDocs" :key="nearIdx">
              <img :src="getDocImg(last)" alt="doc">
              <p class="ove mt10" :title="last.title">{{last.title}}</p>
            </li>
          </ul>
          <p v-else class="mt30 center font18 clo9">暂无报告</p>
        </div>
      </div>
    </section>
    <footer-nav></footer-nav>
  </div>
</template>

<script>
import { $dg_getReportDetail } from '../../api';
import TopNav from '../../components/TopNav';
import FooterNav from '../../components/FooterNav';
import LeftNav from './LeftNav';
import PdfPreview from '../../components/PdfPreview';
import { isLogin } from '../../utils';

export default {
  name: 'Detail',
  data() {
    return {
      year: null,
      month: null,
      week: null,
      docList: [],
      code: '',
      fileId: '',
      showPdf: false,
    };
  },
  computed: {
    routes() {
      return this.$store.state.routeName;
    },
    years() {
      const { docList } = this;
      const arr = docList.map(({ title }) => title.split('（')[1].split('年')[0]);
      return Array.from(new Set(arr));
    },
    months() {
      const { year, docList } = this;
      if (!year) return [];
      const split = `（${year}年`;
      const filterArr = docList.filter(v => v.title.includes(split));
      const arr = filterArr.map(item => item.title.split(split)[1].split('月')[0]);
      return Array.from(new Set(arr));
    },
    weeks() {
      const { year, month, docList } = this;
      if (!year || !month) return [];
      const split = `（${year}年${month}月`;
      const filterArr = docList.filter(v => v.title.includes(split));
      const arr = filterArr.map(item => item.title.split(split)[1].split('周')[0]);
      return Array.from(new Set(arr));
    },
    lastDocs() {
      const { docList } = this;
      const arr = [];
      docList.forEach((doc, docIdx) => {
        if (docIdx < 3) arr.push(doc);
      });
      return arr;
    },
    routeQuery() {
      return this.$store.state.routeQuery;
    },
    fileName() {
      return `${this.routes[1]}(${this.year}年${this.month}月${this.week}期)`;
    },
    token() {
      return this.$store.state.userToken;
    },
  },
  watch: {
    years(years) {
      this.year = years[0];
    },
    months(months) {
      this.month = months[0];
    },
    weeks(weeks) {
      this.week = weeks[0];
    },
    week() {
      this.verifyRoot();
    },
    routeQuery() {
      this.getReportDetail();
    },
  },
  components: {
    PdfPreview,
    LeftNav,
    FooterNav,
    TopNav,
  },
  methods: {
    async getReportDetail() {
      const {
        leafId, title, attrName, chnId,
      } = this.routeQuery;
      if (!leafId && !chnId) return;
      const params = {
        lv2Id: leafId || chnId,
      };
      if (attrName) params.attr = attrName;
      const resp = await $dg_getReportDetail(params);
      const { docList } = resp;
      if (!docList) return;
      this.docList = docList;
      if (title) {
        this.changePdfView({ title }, true);
        return;
      }
      if (docList.length) {
        this.changePdfView(docList[0], true);
      }
    },
    async verifyRoot(year = this.year, month = this.month, week = this.week) {
      const result = this.docList.find(v => v.title.includes(`（${year}年${month}月${week}周）`));
      if (!result) return;
      this.showPdf = false;
      this.code = result.code;
      this.fileId = result.fileSourcesCodes;
      this.$nextTick(() => {
        this.showPdf = true;
      });
    },
    changePdfView({ title }, force = false) {
      const year = title.split('（')[1].split('年')[0];
      const month = title.split(`（${year}年`)[1].split('月')[0];
      const week = title.split(`（${year}年${month}月`)[1].split('周')[0];
      if (force) {
        this.year = year;
        this.month = month;
        this.$nextTick(() => {
          this.week = week;
          this.verifyRoot();
        });
        return;
      }
      if (+year != this.year || +month != this.month || week != this.week) { // eslint-disable-line
        this.year = year;
        this.month = month;
        this.$nextTick(() => {
          this.week = week;
          this.verifyRoot();
        });
      }
    },
    getDocImg({ docId }) {
      return `http://www.drcnet.com.cn/www/int/ImageShow.ashx?purposeId=2&docId=${docId}`;
    },
    keepToken() {
      if (this.token) {
        setInterval(() => {
          isLogin();
        }, 3000);
      }
    },
  },
  mounted() {
    this.keepToken();
  },
};
</script>

<style scoped lang="scss">
@import "@/scss/var.scss";
section{
  /deep/
  .el-select{
    width: 200px;
  }
  min-height: calc(100vh - 370px);
  width: 1200px;
  margin: 45px auto 70px;
  .full-line{
    border-top: 1px solid $--primary-color;
    p{
      padding: 20px 10px;
    }
  }
  .href-line{
    height: 4px;
    background: $--primary-color;
  }
  .report-list{
    width: 850px;
    .img-title{
      width: 100%;
      height: 56px;
      margin-top: 50px;
      border: none;
    }
    .title{
      margin-top: 50px;
      font-size: 18px;
      color: $--primary-color;
      font-weight: bold;
      span{
        display: inline-block;
        padding-bottom: 17px;
        border-bottom: 3px solid $--primary-color;
      }
      border-bottom: 1px solid $--primary-color;
    }
    img{
      width: 280px;
      height: 180px;
      border: 1px solid #c6c6c6;
      border-radius: 3px;
    }
    ul{
      margin-top: 65px;
    }
    li{
      width: 280px;
    }
  }
}
</style>
